import { createSlice } from "@reduxjs/toolkit";
import {
  getQuestionWithFilter,
  updateQuestion,
  deleteQuestion,
  bulkDeleteQuestion,
  getQuestionWithId,
  getQuestionPage,
} from "./thunk";

const initialState = {
  questions: {
    data: {
      data: [],
      totalCount: 0,
      currentPage: 1,
      totalPages: 0
    }
  },
  singleQuestion: null,
  loading: false,
  error: null,
  filterParams: {
    currentPage: 1,
    perPage: 20,
  },
};

const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {
    setFilterParams: (state, action) => {
      state.filterParams = action.payload;
    },
    clearSingleQuestion: (state) => {
      state.singleQuestion = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔄 FETCH QUESTIONS (FILTER)
      .addCase(getQuestionWithFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuestionWithFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
        state.error = null;
      })
      .addCase(getQuestionWithFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch questions";
      })

      // 📄 FETCH QUESTIONS (PAGINATED)
      .addCase(getQuestionPage.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuestionPage.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
        state.error = null;
      })
      .addCase(getQuestionPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch question page";
      })

      // 🔍 FETCH SINGLE QUESTION BY ID
      .addCase(getQuestionWithId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuestionWithId.fulfilled, (state, action) => {
        state.loading = false;
        state.singleQuestion = action.payload;
        state.error = null;
      })
      .addCase(getQuestionWithId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch question";
      })

      // ✏️ UPDATE QUESTION
      .addCase(updateQuestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.singleQuestion = action.payload;
        state.error = null;
      })
      .addCase(updateQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update question";
      })

      // 🗑️ DELETE QUESTION
      .addCase(deleteQuestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteQuestion.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to delete question";
      })

      // 🗑️ BULK DELETE QUESTIONS
      .addCase(bulkDeleteQuestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkDeleteQuestion.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(bulkDeleteQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to delete questions";
      });
  },
});

export const { setFilterParams, clearSingleQuestion } = questionSlice.actions;
export default questionSlice.reducer;
